import React, {useState} from 'react';
import {Collapse} from 'antd';
import './style.css';
import useLocalization from '../../../Localization';

const {Panel} = Collapse;

const CustomCollapse = ({data, titleHide}) => {
  const {ApplicationString} = useLocalization();
  const [activeKey, setActiveKey] = useState(null);

  const handleCollapseChange = (keys) => {
    setActiveKey(keys[0]);
  };

  if (!data) {
    data = [
      {
        title: ApplicationString['faqComponent.faq.content.title'],
        content: ApplicationString['faqComponent.faq.content.description'],
      },
      {
        title: ApplicationString['faqComponent.faq.content.title2'],
        content: ApplicationString['faqComponent.faq.content.description2'],
      },
      {
        title: ApplicationString['faqComponent.faq.content.title3'],
        content: ApplicationString['faqComponent.faq.content.description3'],
      },
      {
        title: ApplicationString['faqComponent.faq.content.title4'],
        content: ApplicationString['faqComponent.faq.content.description4'],
      },
      {
        title: ApplicationString['faqComponent.faq.content.title5'],
        content:
          ApplicationString[
            'sponsorInfoDetailsComponent.content.cancellationPolicy'
          ],
      },
    ];
  }

  return (
    <React.Fragment>
      <div className={`${!titleHide && 'collapse-container-e23'}`}>
        {!titleHide && (
          <p className='collapse-title'>
            {ApplicationString['userAddAttendeeComponent.faq']}
          </p>
        )}
        <Collapse
          expandIconPosition='end'
          prefixCls='custom-collapse'
          onChange={handleCollapseChange}>
          {data.map((item, index) => (
            <Panel
              id={`aboutUs-FAQCollapse-${index}`}
              header={item.title}
              key={index}
              className={activeKey === index ? 'active-panel' : ''}>
              {/* {item.content} */}
              <div
                dangerouslySetInnerHTML={{__html: item.content}}
                className='collapse-content'
              />
            </Panel>
          ))}
        </Collapse>
      </div>
    </React.Fragment>
  );
};

export default CustomCollapse;
